import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GamificationSummaryDto, UseConsultationDto } from '@bemum/api-interfaces';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class GamificationService {
  constructor(private http: HttpClient) {}

  getSummary(patientId: string) {
    return this.http.get<GamificationSummaryDto>(`${environment.api_url}/gamification/patient/${patientId}/summary`);
  }

  useConsultation(patientId: string) {
    const dto: UseConsultationDto = { patientId };
    return this.http.post(`${environment.api_url}/gamification/consultation/use`, dto);
  }
}
